import _ from 'lodash'
import $ from 'jquery'
import 'cropperjs'
import 'jquery-cropper'

export default {
  name: 'KCrop',
  components: {},
  mixins: [],
  props: {
    url: {
      type: String,
    },
    defaultUrl: {
      type: String,
    },
    title: {
      type: String,
      default: '图像',
    },
    ratio: {
      type: Number,
    },
    mode: {
      type: Number,
      default: 2,
    },
    // 裁剪区域包含图片
    coverImage: {
      type: Boolean,
      default: false,
    },
    // 预览元素 https://github.com/fengyuanchen/cropperjs#preview
    preview: {
      type: Boolean,
      default: true,
    },
    previewContainer: {
      type: String,
      default: '.km-crop__preview-item',
    },
    onChange: {
      type: Function,
      default: _.noop,
    },
    className: {
      type: String,
    },
    size: {
      type: Number,
      default: 360,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {},
  watch: {
    url(val) {
      if (val) {
        const $image = $(this.$refs.image)
        if ($image && $image.data('cropper')) {
          $image.data('cropper').replace(val)
        } else {
          _.delay(this.initCrop, 0)
        }
      }
    },
  },
  methods: {
    initCrop() {
      if (!this.loaded || !this.url) {
        return
      }
      $(this.$refs.image).cropper({
        aspectRatio: this.ratio,
        // see: https://github.com/fengyuanchen/cropperjs#viewmode
        viewMode: this.mode,
        dragMode: 'move',
        guides: false,
        center: false,
        // 高亮裁剪区域
        highlight: true,
        // 初始化时自动裁剪
        autoCrop: true,
        autoCropArea: 1,
        // 免得太小看不见了...
        minCropBoxWidth: 80,
        minCropBoxHeight: 80,
        preview: this.previewContainer,
        crop: event => {
          this.onChange && this.onChange(event.detail)
        },
      }).on('ready', () => {
        if (this.coverImage) {
          const cropper = $(this.$refs.image).data('cropper')
          const cropBoxData = cropper.getCropBoxData()
          const imageData = cropper.getImageData()
          const offWidth = imageData.width - cropBoxData.width
          const offHeight = imageData.height > cropBoxData.height
          let zoom = 0
          if (offWidth > 0) {
            zoom = (imageData.width / cropBoxData.width) - 1
          } else if (offHeight > 0) {
            zoom = (imageData.height / cropBoxData.height) - 1
          }
          if (zoom) {
            cropper.zoom(-zoom)
          }
        }
      })
    },
  },
  created() {
  },
  mounted() {
    // require.ensure(['cropperjs', 'jquery-cropper'], (require) => {
    //   require('cropperjs')
    //   require('cropperjs/dist/cropper.css')
    //   require('jquery-cropper')
    this.loaded = true
    _.delay(this.initCrop, 0)
    // })
  },
  render() {
    const data = {
      class: {
        'km-crop': true,
        [this.className]: !!this.className,
      },
    }
    return (
      <div {...data} class={this.className}>
        <div
          class="km-crop__wrap"
          style={{ height: this.size + 'px', width: this.size + 'px' }}
        >
          <img
            ref="image"
            class="km-crop__image"
            src={this.url}
          />
        </div>
        {this.preview
          ? <div
            class="km-crop__preview"
            ref="preview"
          >
            <div class="km-crop__preview-item is-normal">
              <img
                class="default-image"
                src={this.defaultUrl}
                alt=""
              />
            </div>
            <div class="has-text-light is-mt-8">方形{this.title}</div>
            <div class="km-crop__preview-item is-circle">
              <img
                class="default-image"
                src={this.defaultUrl}
                alt=""
              />
            </div>
            <div class="has-text-light is-mt-8">圆形{this.title}</div>
          </div> : ''}
      </div>
    )
  },
}
